export function getParsedAuth0Username(baseUn: string): string {
    return baseUn.replace('auth0|', 'auth0.');
}
